import {
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';
import { LocationV2 } from './location.v2.model';

export class WorkspaceV2 {
  id: number = 0;
  name: string = '';
  location_id: number = 0;
  location?: LocationV2;
  amount_rbt?: number;
  amount_bcba?: number;
  amount_manager?: number;
  amount_client?: number;
  info_rbt?: [];
  info_bcba?: [];
  info_manager?: [];
  constructor(data: Partial<WorkspaceV2> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.name = StringOrNullOrUndefined(data.name) ?? '';
    this.location_id = NumberOrNullOrUndefined(data.location_id) ?? 0;
    this.location = data.location ?? undefined;
    this.amount_rbt = NumberOrNullOrUndefined(data.amount_rbt);
    this.amount_bcba = NumberOrNullOrUndefined(data.amount_bcba);
    this.amount_manager = NumberOrNullOrUndefined(data.amount_manager);
    this.amount_client = NumberOrNullOrUndefined(data.amount_client);

    this.info_rbt = data.info_rbt ?? [];
    this.info_bcba = data.info_bcba ?? [];
    this.info_manager = data.info_manager ?? [];
  }
}